module.exports = __webpack_public_path__ + "img/banner.c17828ab.jpg";